import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useGeolocationStore } from "@/common/store/geolocationStore";
import { useUserStore } from "@/common/store";
import { isPageAllowed, getAlternatePage, AGE_VERIFICATION_COUNTRIES } from "@/common/utils/geoRules";

export const useGeoBlockedPage = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const location = useGeolocationStore((state) => state.location);
  const currentUser = useUserStore((state) => state.currentUser);

  useEffect(() => {
    if (isPageAllowed(pathname, location)) {
      return;
    }

    if (currentUser === undefined || currentUser?.verified) {
      return;
    }

    if (currentUser?.username && AGE_VERIFICATION_COUNTRIES.includes(location?.country || "")) {
      return;
    }

    const alternatePage = getAlternatePage(pathname, location);

    if (!alternatePage) {
      return;
    }

    if (alternatePage.startsWith("https://")) {
      window.location.replace(alternatePage);
      return;
    }

    navigate(alternatePage, { replace: true });
  }, [pathname, location, currentUser, navigate]);
};
